import { render } from "./SpendingTargetInfo.vue?vue&type=template&id=455e8745&scoped=true"
import script from "./SpendingTargetInfo.vue?vue&type=script&lang=js"
export * from "./SpendingTargetInfo.vue?vue&type=script&lang=js"

import "./SpendingTargetInfo.vue?vue&type=style&index=0&id=455e8745&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-455e8745"]])

export default __exports__